<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import scholarshipApi from '@/services/api/scholarship.api'
import reportApi from '@/modules/report/api'
import DocumentsService from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-chart-pie',
      title: 'Jornal de Pagos',
      routes: ["Inicio", "Informes Generales", "Jornal de Pagos"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          statuses: [],
        },
        filters: {
          academicYear: null,
          status: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Año Fiscal',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año fiscal.",
        validations: "required",
        class: "col-md-3",
        clearable: false,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
      },
      {
        name: 'status',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Estatus',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        options: this.model.search.collections.statuses,
        value: this.model.search.filters.status,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      const { data } = await scholarshipApi.getJournalInitFilters();
      this.model.search.collections.academicYears = [...data.collections.academicYears];
      this.model.search.collections.statuses = [...data.collections.status];
    },
    async onHandlerSearch() {
      if (!this.model.search.filters.academicYear?.id) return;
      this.process();
    },
    async process() {
      const payload = {
        academicYearId: this.model.search.filters.academicYear?.id,
        statusId: this.model.search.filters.status?.id,
      };

      reportApi
        .getReport('paymentjournals', payload)
        .then((res) => DocumentsService.Download(res.data));
    },
  },
}
</script>